"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Toggle = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Toggle"));
var styles = {
  "filters-toggle": "filters-toggle_2YRhvC",
  "filtersToggle": "filters-toggle_2YRhvC"
}; 
require('./FiltersToggle.css');
const FiltersToggle = ({
  showFilters,
  onChange
}) => {
  const handleChange = ({
    value
  }) => {
    onChange === null || onChange === void 0 || onChange(value);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: styles.filtersToggle
  }, /*#__PURE__*/_react.default.createElement("span", {
    id: "filters-toggle-label"
  }, "Show filters"), /*#__PURE__*/_react.default.createElement(_Toggle.default, {
    checked: showFilters,
    onChange: handleChange,
    testId: "filters",
    "aria-describedby": "filters-toggle-label"
  }));
};
var _default = exports.default = FiltersToggle;
//# sourceMappingURL=FiltersToggle.js.map